import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { RouteComponentProps } from 'react-router';

import { getQueryParams } from '../../../utils/services/queryParams';
import { Grid, GridColumn, ModalTitle, ModalSubtitle } from '../../../core/components/styled';
import { createSuccessNotification, createErrorNotification } from '../../../core/services/createNotification';
import { Modal } from '../../../core/components';
// import pricingInfoIntialValueSelector from '../../services/pricingInfoIntialValueSelector';
import translate from '../../../core/services/translate';
import { AcceptPaymentForSelectedProcessedServiceForm } from '../forms';
import { PROCESSED_SERVICE, LIMIT_PER_PAGE } from '../../constants';
import { AppState } from '../../../store';

interface RouteParams {
  token: string;
}

interface ComponentProps {
  pricingInfo: any;
  vendorId: number;
  updateAcceptSelectedProcessedPaymentServices(...args: any[]): any;
  onCancel(...args: any[]): any;
}

interface Props extends ComponentProps, RouteComponentProps<RouteParams> {
  workOrdersInfo: any;
  pricingInfo: any;
  selectedPaymentInfo: any;
  paymentInfo: any;
  isSaving: boolean;
}

class AcceptPaymentForSelectedProcessedModal extends PureComponent<Props> {
  onSubmit = async () => {
    const {
      match: {
        params: { token },
      },
      vendorId,
      selectedPaymentInfo,
      location,
      onCancel,
    } = this.props;
    const { page } = getQueryParams(location.search);
    const requestProcessedServicesObj: any = {};

    requestProcessedServicesObj.serviceType = PROCESSED_SERVICE;
    requestProcessedServicesObj.paymentMethod = selectedPaymentInfo.paymentMethods;
    requestProcessedServicesObj.paymentId = selectedPaymentInfo.paymentId;
    requestProcessedServicesObj.rubiconInvoiceNo = selectedPaymentInfo.rubiconInvoiceNo;

    await this.props
      .updateAcceptSelectedProcessedPaymentServices(requestProcessedServicesObj, vendorId, token, page, LIMIT_PER_PAGE)
      .then(() => {
        createSuccessNotification(translate('opportunity.opportunitySave'));
        onCancel(true);
      })
      .catch(() => {
        createErrorNotification(translate('opportunity.opportunitySaveError'));
      });
  };

  stopPropagation = (event: any) => {
    event.preventDefault();
  };

  render() {
    const { isSaving, onCancel } = this.props;

    return (
      <Modal size="small" isLoading={isSaving}>
        <ModalTitle>{translate('payment.acceptPayment')}</ModalTitle>
        <ModalSubtitle />
        <Grid centered>
          <GridColumn size="8/12">
            <AcceptPaymentForSelectedProcessedServiceForm
              {...this.props}
              onSubmit={this.onSubmit}
              onCancel={onCancel}
            />
          </GridColumn>
        </Grid>
      </Modal>
    );
  }
}

const formSelector = formValueSelector('acceptPaymentForSelectedProcessedService');

const mapStateToProps = (state: AppState, ownProps: ComponentProps) => ({
  workOrdersInfo: state.payments.processedServices.workOrdersInfo,
  pricingInfo: state.payments.processedServices.pricingInfo,
  selectedPaymentInfo: formSelector(state, `pricingInfo.settings${ownProps.pricingInfo.rubiconInvoiceNo}`),
  paymentInfo: state.payments.processedServices.paymentInfo,
  isSaving: state.payments.processedServices.isSaving,
});

export default connect(mapStateToProps, undefined)(AcceptPaymentForSelectedProcessedModal);
